import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 27px;
  margin: 0 0 28px 0;

  .text-block {
    display: flex;
    font-size: 36px;
    font-family: 'Kanit-SemiBold';
    gap: 10px;

    .text-cta {
      text-align: center;
      p {
        margin: 0;
        padding: 0;
        font-size: 36px;
      }

      a {
        font-size: 36px;
        color: ${theme.red};
      }
    }
  }

  .btn-block {
    button {
      span {
        font-family: 'Kanit-SemiBold';
        font-size: 32px;
      }
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 18px;
    .text-block {
      font-size: 20px;
      font-family: 'Kanit-Bold';
      gap: 5px;

      .text-cta {
        text-align: center;
        p {
          margin: 0;
          padding: 0;
          font-size: 32px;
        }

        a {
          font-size: 32px;
          color: ${theme.red};
        }
      }
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .text-block {
      font-size: 20px;
      font-family: 'Kanit-Bold';
      gap: 5px;

      .text-cta {
        p {
          margin: 0;
          padding: 0;
          font-size: 20px;
        }

        a {
          font-size: 20px;
          color: ${theme.red};
        }
      }
    }

    .btn-block {
      button {
        min-width: 120px;
        min-height: 45px;
        span {
          font-family: 'Kanit-SemiBold';
          font-size: 16px;
        }
      }
    }
  }
`
